var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.2 1.142a.451.451 0 01.666.008.522.522 0 01-.008.708l-4.812 5a.451.451 0 01-.658 0L.142 4.524a.522.522 0 01-.008-.707A.451.451 0 01.8 3.81l1.917 1.992L7.2 1.142z",
    id: "check_svg__a"
  }))), /*#__PURE__*/React.createElement("use", {
    fill: props.color,
    opacity: 0.9,
    xlinkHref: "#check_svg__a",
    transform: "translate(0 -1)",
    fillRule: "evenodd"
  }));
}
export default SvgCheck;